import type { SubmissionStatus } from './schemas.ts';

// An answer becomes read-only once its owner (company / driver / asset) has
// submitted — EXCEPT one the admin rejected, which reopens so the submitter can
// correct just that question. Editing a reopened answer flips it back to
// 'pending' (the existing PUT behaviour), re-locking it until the next review.
export function isAnswerLocked(
  ownerSubmittedAt: string | null | undefined,
  existingStatus: SubmissionStatus | null | undefined,
): boolean {
  if (!ownerSubmittedAt) return false;
  return existingStatus !== 'rejected';
}
